import { render, staticRenderFns } from "./button-typical.vue?vue&type=template&id=52eb06d0"
import script from "./button-typical.vue?vue&type=script&lang=js"
export * from "./button-typical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports